export default {
    root: ({context}) => ({
        class: [
            "flex items-center justify-between font-bold leading-none p-5 border border-stone-200 dark:border-stone-700 bg-stone-50 dark:bg-stone-800 text-stone-600 dark:text-stone-0/80 transition duration-200 ease-in-out",
            {
                "focus-visible:outline-none focus-visible:border-askr-green-500 dark:focus-visible:border-askr-green-400 focus-visible:ring-2 focus-visible:ring-askr-green-400/20 dark:focus-visible:ring-askr-green-300/20":
                    !context.disabled,
            },
            {
                "hover:text-stone-700 dark:hover:text-stone-0": !context.disabled,
            },
        ],
    }),
    toggleIcon: "text-stone-600 dark:text-stone-0/80",
};
